import { bov3_api } from '../..';
import { PropertyType } from '../../../common';

export const getPartnerGames = (data: PropertyType): Promise<PropertyType> =>
	bov3_api
		.post(``, {
			sid: data.token,
			partner_id: data.partner_id,
			request: 'GetPartnerGames',
		})
		.then((res) => {
			return res.data;
		});
